import { authHeader } from '../utils/auth-header';
import apis from '../config/api';
import axios from "axios";

export const prebookingService = {
    getOfferings,
    createBooking,
    calculateDealPricing,
    getAvailableSpaces
};

function getOfferings(locationId,startDate) {
    let query=`locationId=${locationId}&startDate=${startDate.toJSON()}`;
    return axios.get(`${apis.prebooking}/offerings?${query}`, { headers: authHeader() });
}

function createBooking(booking) {
    return axios.post(`${apis.prebooking}/booking`,booking, { headers: authHeader() });
}
function calculateDealPricing(locationId,offeringId){
    return axios.get(`${apis.prebooking}/offeringPrice/${offeringId}/${locationId}`,{headers: authHeader() });
}
function getAvailableSpaces(locationId,startDate, endDate){
    return axios.get(`${apis.prebooking}/spaces?locationId=${locationId}&startDate=${startDate}&endDate=${endDate}`,{headers: authHeader() });
}




// WEBPACK FOOTER //
// ./src/services/prebookingService.js